module.exports = __webpack_public_path__ + "img/UserExperiences.eeadb418.svg";